// extracted by mini-css-extract-plugin
export default {"strip":"kxiDe","root":"AIeT1","title":"ya+PQ","listOfBenefits":"nXbYh","benefit":"gLK-1","benefitTextBox":"J9kFr","benefitTitle":"eJn4i","benefitDescription":"Ic4ZY"};